import apiRates from '../../api/apiRates'

const state = {
    isActive: false,
    activeLot: null,
    isLoading: false,
    errorStatus: false,
    errorMessage: null,
    currentBid: {
        id: '',
        status:  '',
        amount_yen:  null,
        amount_usd: null,
        lot_id: '',
        group: {}
    }
}

const getters = {
    getResultActiveBiddingModalStatus: (state) => {
        return state.isActive
    },
    getResultActiveBiddingModalLot: (state) => {
        return state.activeLot
    },
    getResultActiveBiddingModalLoadingStatus: (state) => {
        return state.isLoading
    },
    getResultActiveBiddingModalErrorStatus: (state) => {
        return state.errorStatus
    },
    getResultActiveBiddingModalErrorMessage: (state) => {
        return state.errorMessage
    },
    getResultActiveBiddingModalBidAmountYen: (state) => {
        return state.currentBid.amount_yen
    },
    getResultActiveBiddingModalBidAmountUsd: (state) => {
        return state.currentBid.amount_usd
    },
    getResultActiveBiddingModalDisabledStatus: (state) => {
        return state.currentBid.amount_yen === null && state.currentBid.amount_usd === null
    },
    getResultActiveBiddingModalCurrentBid: (state) => {
        return state.currentBid
    }
}

const mutations = {
    setResultBiddingModalStatus: (state, value) => {
        state.isActive = value.status
        state.activeLot = value.lot
        state.currentBid.lot_id = value.lot.lot_id
        if (value.lot.bids.length > 0) {
            state.currentBid = value.lot.bids[0]
            state.bidAmountYen = value.lot.bids[0].amount_yen
            state.bidAmountUsd = value.lot.bids[0].amount_usd
            state.errorStatus = false
            state.errorMessage = ''
        }
    },
    setResultBiddingModalValuesToDefault: (state) => {
        state.isActive = false
        state.activeLot = null
        state.isLoading = false
        state.errorStatus = false
        state.errorMessage = null
        state.bidAmountYen = null
        state.bidAmountUsd = null
        state.currentBid = {
            id: '',
            status:  '',
            amount_yen:  null,
            amount_usd: null,
            lot_id: '',
            group: {}
        }
    },
    setResultBiddingModalLoadingStatus: (state, value) => {
        state.isLoading = value
    },
    setResultBiddingModalBidAmountYen: (state, value) => {
        state.currentBid.amount_yen = value
    },
    setResultBiddingModalBidAmountUsd: (state, value) => {
        state.currentBid.amount_usd = value
    },
    setResultActiveBiddingModalErrorStatus: (state, value) => {
        state.errorStatus = value
    },
    setResultActiveBiddingModalErrorMessage: (state, value) => {
        state.errorMessage = value
    },
    setResultActiveBiddingModalCurrentBidGroup: (state, value) => {
        state.currentBid.group = value
    }
}

const actions = {
    changeResultBiddingModalStatus: ({ commit }, value) => {
        commit('setResultBiddingModalStatus', value)
    },
    resetResultBiddingModal: ({commit, dispatch}) => {
        commit('setResultBiddingModalValuesToDefault')
        dispatch('changeSearchResultActiveLotKey', null)
    },
    changeResultBiddingModalBidAmountYen: ({ commit }, value) => {
        commit('setResultBiddingModalBidAmountYen', value)
    },
    changeResultBiddingModalBidAmountUsd: ({ commit }, value) => {
        commit('setResultBiddingModalBidAmountUsd', value)
    },
    changeResultActiveBiddingModalErrorStatus: ({ commit }, value) => {
        commit('setResultActiveBiddingModalErrorStatus', value)
    },
    changeResultActiveBiddingModalErrorMessage: ({ commit }, value) => {
        commit('setResultActiveBiddingModalErrorMessage', value)
    },
    changeResultBiddingModalLoadingStatus: ({ commit }, value) => {
        commit('setResultBiddingModalLoadingStatus', value)
    },
    changeResultActiveBiddingModalCurrentBidGroup: ({ commit, getters }) => {
        commit('setResultActiveBiddingModalCurrentBidGroup', getters.getSelectedGroup)
    },
    convertResultBiddingModalBidAmountYenToUsd: ({ commit, state }) => {
        commit('setResultBiddingModalLoadingStatus', true)
        apiRates
            .convertYenRequest({ amount_yen: state.currentBid.amount_yen })
            .then((response) => {
                commit('setResultBiddingModalBidAmountUsd', response.data)
                commit('setResultBiddingModalLoadingStatus', false)
            })
            .catch((err) => {
                console.log(err)
                commit('setResultBiddingModalLoadingStatus', false)
            })
    },
    convertResultBiddingModalBidAmountUsdToYen: ({ commit, state }) => {
        commit('setResultBiddingModalLoadingStatus', true)
        apiRates
            .convertUsdRequest({ amount_usd: state.currentBid.amount_usd })
            .then((response) => {
                commit('setResultBiddingModalBidAmountYen', response.data)
                commit('setResultBiddingModalLoadingStatus', false)
            })
            .catch((err) => {
                console.log(err)
                commit('setResultBiddingModalLoadingStatus', false)
            })
    }

}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/resultBiddingModal.js